module.exports = __webpack_public_path__ + "static/media/slide-1mr.1e84c48e.jpg";